import React from 'react';

import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import EmptyBoxSvg from '../../../svgs/empty-box.svg';
import { messages } from './messages';

import buttonTextStyle from 'ui-components/components/button/button-text.module.less';
import style from './sender-emails-table-empty-row.module.less';

export const SenderEmailsTableEmptyRow = () => {
  return (
    <FlexColumn className={style['empty-row']}>
      <img alt='Empty Box' src={EmptyBoxSvg} />
      <Text textType={TextType.Caption} value={messages.noSenderEmailsInstructions} />
      <Link className={classnames(buttonTextStyle['button-text'], style['store-settings-link'])} to='/settings/stores'>
        <FormattedMessage {...messages.storeSettingsLink} />
      </Link>
    </FlexColumn>
  );
};
